export const FAQS = [
  {
    q: "Apa itu Sloto69?",
    a: "Sloto69 adalah brand digital berbahasa Indonesia yang fokus menyediakan pusat informasi, panduan pengguna, dan dukungan akses yang mudah dimengerti. Website company profile ini dibuat agar pengguna baru maupun lama dapat menemukan informasi resmi seputar layanan Sloto69 dalam satu tempat.",
  },
  {
    q: "Bagaimana cara login Sloto69?",
    a: "Pengguna dapat mempelajari langkah-langkah login Sloto69 secara lengkap pada halaman Panduan Login. Pastikan selalu mengakses melalui link resmi, periksa alamat website sebelum memasukkan data, dan jangan pernah membagikan informasi akun Anda kepada pihak lain.",
  },
  {
    q: "Apa fungsi link alternatif Sloto69?",
    a: "Link alternatif Sloto69 berfungsi sebagai jalur cadangan apabila link utama tidak dapat diakses karena kendala jaringan, ISP, atau alasan teknis lainnya. Halaman Link Alternatif kami selalu memuat informasi terbaru sehingga pengguna tetap dapat mengakses informasi resmi.",
  },
  {
    q: "Bagaimana cara daftar akun Sloto69?",
    a: "Proses daftar Sloto69 dapat dipelajari pada halaman Panduan Daftar. Halaman tersebut menjelaskan langkah demi langkah dengan tampilan yang ringan dan mudah dimengerti agar pengguna baru tidak mengalami kesulitan.",
  },
  {
    q: "Mengapa harus menggunakan link resmi?",
    a: "Menggunakan link resmi adalah langkah penting untuk menjaga keamanan informasi pribadi. Banyak situs tiruan beredar di internet sehingga periksa selalu alamat website, hindari klik tautan dari sumber tidak dikenal, dan rujuk halaman ini sebagai referensi utama.",
  },
  {
    q: "Apakah website ini bisa diakses lewat HP?",
    a: "Ya, seluruh halaman Sloto69 dirancang dengan pendekatan mobile-first sehingga ringan, cepat, dan nyaman dibuka melalui smartphone, tablet, maupun desktop tanpa perubahan fungsi.",
  },
  {
    q: "Bagaimana jika link utama tidak bisa dibuka?",
    a: "Jika link utama mengalami kendala, kunjungi halaman Link Alternatif Sloto69 untuk memperoleh daftar URL cadangan terbaru. Anda juga dapat menghubungi tim bantuan kami melalui WhatsApp atau Telegram.",
  },
  {
    q: "Di mana mendapatkan informasi terbaru Sloto69?",
    a: "Informasi terbaru Sloto69 selalu kami publikasikan pada halaman Artikel dan halaman Link Alternatif. Anda juga dapat memantau pembaruan keamanan, panduan, dan tips melalui menu utama website.",
  },
  {
    q: "Apakah Sloto69 menyediakan dukungan pengguna?",
    a: "Tentu. Tim bantuan Sloto69 dapat dihubungi melalui kanal kontak resmi pada halaman Kontak. Kami siap membantu menjawab pertanyaan seputar informasi, panduan, dan pembaruan link resmi.",
  },
  {
    q: "Apakah informasi di website ini gratis?",
    a: "Ya, seluruh konten edukatif, panduan, dan informasi pada website company profile Sloto69 dapat diakses tanpa biaya. Tujuan utama kami adalah membantu pengguna Indonesia mendapatkan informasi yang jelas dan terpercaya.",
  },
];
